module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/music-35553b7537d97544949a489e8cf96cf0.svg";